export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_dtf-tool-staging/artifacts/j4q9exyq_ChatGPT%20Image%2020%20de%20set.%20de%202026%2C%2023_35_33.png";

export const PRINTER_ILLUSTRATION =
  "https://static.prod-images.emergentagent.com/jobs/bee06ef3-0ab9-4ec4-9f8c-06fac5425eed/images/be37582fe7cac97bb9cbbb64c3399ac89b8f6ae1aefb00830850a5da9d792dcb.jpeg";
